import { render, staticRenderFns } from "./AffiliateHeader.vue?vue&type=template&id=39a741f8&scoped=true"
import script from "./AffiliateHeader.vue?vue&type=script&lang=js"
export * from "./AffiliateHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a741f8",
  null
  
)

export default component.exports